module.exports = __webpack_public_path__ + "img/gongzuo.62f783aa.svg";